import { render, staticRenderFns } from "./add.vue?vue&type=template&id=68622e16&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=68622e16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68622e16",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/supplier/add.vue
// module id = null
// module chunks = 